import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as PuzzleIcon } from './puzzle.svg';

export const Puzzle = IconHOC(PuzzleIcon);
